module.exports = __webpack_public_path__ + "static/father-and-daughter-swimming-in-a-pool.cbff9feb.webp";